const capqueue = (state = [], action) => {
    switch (action.type) {
      case 'CAP_QUEUE':
      return {
          type: "CAP_QUEUE",
          capturafila: action.capturafila
        }
      default:
        return state
    }
  }
  
  export default capqueue